<label [for]="elementId">
  <input [id]="elementId" type="checkbox" (click)="toggleButton($event)"> {{label}}
</label>
